/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentFeatureValuesResult } from './DocumentFeatureValuesResult';
import {
	DocumentFeatureValuesResultFromJSON,
	DocumentFeatureValuesResultFromJSONTyped,
	DocumentFeatureValuesResultToJSON,
	DocumentFeatureValuesResultToJSONTyped,
} from './DocumentFeatureValuesResult';
import type { EasyClaimDocumentType } from './EasyClaimDocumentType';
import {
	EasyClaimDocumentTypeFromJSON,
	EasyClaimDocumentTypeFromJSONTyped,
	EasyClaimDocumentTypeToJSON,
	EasyClaimDocumentTypeToJSONTyped,
} from './EasyClaimDocumentType';
import type { EasyClaimDocumentValidationResult } from './EasyClaimDocumentValidationResult';
import {
	EasyClaimDocumentValidationResultFromJSON,
	EasyClaimDocumentValidationResultFromJSONTyped,
	EasyClaimDocumentValidationResultToJSON,
	EasyClaimDocumentValidationResultToJSONTyped,
} from './EasyClaimDocumentValidationResult';

/**
 *
 * @export
 * @interface EasyClaimDocumentDto
 */
export interface EasyClaimDocumentDto {
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimDocumentDto
	 */
	documentId?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof EasyClaimDocumentDto
	 */
	creationDate?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimDocumentDto
	 */
	fileName?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof EasyClaimDocumentDto
	 */
	fileContent?: string | null;
	/**
	 *
	 * @type {EasyClaimDocumentType}
	 * @memberof EasyClaimDocumentDto
	 */
	documentType?: EasyClaimDocumentType;
	/**
	 *
	 * @type {Array<EasyClaimDocumentValidationResult>}
	 * @memberof EasyClaimDocumentDto
	 */
	validationResults?: Array<EasyClaimDocumentValidationResult> | null;
	/**
	 *
	 * @type {DocumentFeatureValuesResult}
	 * @memberof EasyClaimDocumentDto
	 */
	documentFeatureValues?: DocumentFeatureValuesResult;
}

/**
 * Check if a given object implements the EasyClaimDocumentDto interface.
 */
export function instanceOfEasyClaimDocumentDto(value: object): value is EasyClaimDocumentDto {
	return true;
}

export function EasyClaimDocumentDtoFromJSON(json: any): EasyClaimDocumentDto {
	return EasyClaimDocumentDtoFromJSONTyped(json, false);
}

export function EasyClaimDocumentDtoFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EasyClaimDocumentDto {
	if (json == null) {
		return json;
	}
	return {
		documentId: json['documentId'] == null ? undefined : json['documentId'],
		creationDate: json['creationDate'] == null ? undefined : new Date(json['creationDate']),
		fileName: json['fileName'] == null ? undefined : json['fileName'],
		fileContent: json['fileContent'] == null ? undefined : json['fileContent'],
		documentType:
			json['documentType'] == null
				? undefined
				: EasyClaimDocumentTypeFromJSON(json['documentType']),
		validationResults:
			json['validationResults'] == null
				? undefined
				: (json['validationResults'] as Array<any>).map(EasyClaimDocumentValidationResultFromJSON),
		documentFeatureValues:
			json['documentFeatureValues'] == null
				? undefined
				: DocumentFeatureValuesResultFromJSON(json['documentFeatureValues']),
	};
}

export function EasyClaimDocumentDtoToJSON(json: any): EasyClaimDocumentDto {
	return EasyClaimDocumentDtoToJSONTyped(json, false);
}

export function EasyClaimDocumentDtoToJSONTyped(
	value?: EasyClaimDocumentDto | null,
	ignoreDiscriminator: boolean = false
): any {
	if (value == null) {
		return value;
	}

	return {
		documentId: value['documentId'],
		creationDate:
			value['creationDate'] == null ? value['creationDate'] : value['creationDate'].toISOString(),
		fileName: value['fileName'],
		fileContent: value['fileContent'],
		documentType: EasyClaimDocumentTypeToJSON(value['documentType']),
		validationResults:
			value['validationResults'] == null
				? undefined
				: (value['validationResults'] as Array<any>).map(EasyClaimDocumentValidationResultToJSON),
		documentFeatureValues: DocumentFeatureValuesResultToJSON(value['documentFeatureValues']),
	};
}
